// src/modules/app-views/omnichannel/pages/Init/dashboard/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const OmnichannelDashboard = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <div>DASHBOARD</div>;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default OmnichannelDashboard;
